module.exports = __webpack_public_path__ + "static/img/14001010.f1c53563.png";